function updateDataLayer(type, item, second_item = "") {
  window.dataLayer = window.dataLayer || [];
  switch (type) {
    case "navbar": {
      window.dataLayer.push({
        event: "menu_navbar",
        menu_item: item,
        position: "navbar",
      });
      break;
    }
    case "footer": {
      let language = "";
      let socialType = "";

      if (item.includes("language")) {
        language = item.replace("language_", "");
        item = "language";
      } else if (item.includes("social")) {
        socialType = item.replace("social_", "");
        item = "social";
      }

      window.dataLayer.push({
        event: "footer",
        footer_item: item,
        language: language,
        social_type: socialType,
        position: "footer",
      });
      break;
    }
    case "hamburger": {
      window.dataLayer.push({
        event: "menu_hamburger",
        menu_item: item,
        menu_subitem: second_item,
        position: "menu_hamburger",
      });
      break;
    }
    case "login": {
      const user_email_md5 = CryptoJS.MD5(item).toString(CryptoJS.enc.Hex);
      const user_email_sha256 = CryptoJS.SHA256(item).toString(
        CryptoJS.enc.Hex
      );

      window.dataLayer.push({
        event: "login",
        user_email_md5: user_email_md5,
        user_email_sha256: user_email_sha256,
      });
      break;
    }
    case "register": {
      const user_email_md5 = CryptoJS.MD5(item).toString(CryptoJS.enc.Hex);
      const user_email_sha256 = CryptoJS.SHA256(item).toString(
        CryptoJS.enc.Hex
      );

      window.dataLayer.push({
        event: "new_registration",
        user_email_md5: user_email_md5,
        user_email_sha256: user_email_sha256,
      });
      break;
    }
    case "newsletter": {
      const user_email_md5 = CryptoJS.MD5(item).toString(CryptoJS.enc.Hex);
      const user_email_sha256 = CryptoJS.SHA256(item).toString(
        CryptoJS.enc.Hex
      );

      window.dataLayer.push({
        event: "newsletter_subscription",
        newsletter_subscription_result: second_item,
        user_email_md5: user_email_md5,
        user_email_sha256: user_email_sha256,
      });
      break;
    }
    case "search": {
      window.dataLayer.push({
        event: "search_complete",
        search_term: item,
        search_result: second_item,
      });
      break;
    }
    case "book_appointment": {
      window.dataLayer.push({
        event: "booking",
        store_result: item,
        service_store: second_item,
      });
      break;
    }
    case "form_submit": {
      window.dataLayer.push({
        event: "contact_submit",
        contact_form_result: item,
        contact_type: second_item,
      });
      break;
    }
    case "timeless": {
      const user_email_md5 = CryptoJS.MD5(item).toString(CryptoJS.enc.Hex);
      const user_email_sha256 = CryptoJS.SHA256(item).toString(
        CryptoJS.enc.Hex
      );

      window.dataLayer.push({
        event: "second_wrist",
        user_email_md5: user_email_md5,
        user_email_sha256: user_email_sha256,
      });
      break;
    }
    default:
      break;
  }
}

function updateEcommerceDataLayer(type, itemList, price = 0) {
  window.dataLayer = window.dataLayer || [];
  dataLayer.push({ecommerce: null});

  if (price) {
    price = parsePrice(price)
  }

  function parsePrice(ogPrice) {
    let price = ogPrice.replace(".", "")

    return parseFloat(price)
  }

  switch (type) {
    case "view_item_list": {
      window.dataLayer.push({
        event: type,
        ecommerce: {
          items: itemList,
        },
      });
      break;
    }
    case "select_item": {
      window.dataLayer.push({
        event: type,
        ecommerce: {
          items: itemList,
        },
      });
      break;
    }
    case "view_item": {
      break;
      window.dataLayer.push({
        event: type,
        currency: ShopifyAnalytics.meta.currency,
        value: price,
        ecommerce: {
          items: itemList,
        },
      });
    break;
    }
    case "add_to_cart": {
      break;
      window.dataLayer.push({
        event: type,
        currency: ShopifyAnalytics.meta.currency,
        value: price,
        ecommerce: {
          items: itemList,
        },
      });
      break;
    }
    case "remove_from_cart": {
      break;
      window.dataLayer.push({
        event: type,
        currency: ShopifyAnalytics.meta.currency,
        value: price,
        ecommerce: {
          items: itemList,
        },
      });
      break;
    }
    case "view_cart": {
      break;
      window.dataLayer.push({
        event: type,
        currency: ShopifyAnalytics.meta.currency,
        value: price,
        ecommerce: {
          items: itemList,
        },
      });
      break;
    }
    case "add_to_wishlist": {
      window.dataLayer.push({
        event: type,
        currency: ShopifyAnalytics.meta.currency,
        value: price,
        ecommerce: {
          items: itemList,
        },
      });
      break;
    }
    case "remove_from_wishlist": {
      window.dataLayer.push({
        event: type,
        currency: ShopifyAnalytics.meta.currency,
        value: price,
        ecommerce: {
          items: itemList,
        },
      });
      break;
    }
    case "add_shipping_info": {
      break;
      window.dataLayer.push({
        event: type,
        ecommerce: {
          currency: ShopifyAnalytics.meta.currency,
          value: Shopify.checkout.total_price,
          coupon: "",
          shipping_tier: Shopify.checkout.shipping_rate.title,
          items: itemList,
        },
      });
      break;
    }
    case "add_payment_info": {
      break;
      window.dataLayer.push({
        event: type,
        ecommerce: {
          currency: ShopifyAnalytics.meta.currency,
          value: Shopify.checkout.total_price,
          coupon: "",
          payment_type: Shopify.checkout.payment_url.includes("deposit")
            ? "Bank Deposit"
            : "Credit Card",
          items: itemList,
        },
      });
      break;
    }
    case "purchase": {
      break;
      window.dataLayer.push({
        event: type,
        payment_type: Shopify.checkout.payment_url.includes("deposit")
          ? "Bank Deposit"
          : "Credit Card",
        shipping_tier: Shopify.checkout.shipping_rate.title,
        ecommerce: {
          currency: ShopifyAnalytics.meta.currency,
          value: Shopify.checkout.total_price,
          coupon: Shopify.checkout.shipping_rate.title,
          shipping_tier: "",
          tax: Shopify.checkout.tax_lines.reduce((acc, tax) => (acc += tax), 0),
          shipping: Shopify.checkout.shipping_rate.price,
          affiliation: "Pisa 1940",
          transaction_id: Shopify.checkout.order_id,
          coupon: "",
          items: itemList,
        },
      });
      break;
    }
    case "refund": {
      const {transaction_id, value, tax, shipping} = itemList[0];

      window.dataLayer.push({
        event: type,
        ecommerce: {
          transaction_id,
          value,
          tax,
          shipping,
          currency: ShopifyAnalytics.meta.currency,
        },
      });
      break;
    }
    default:
      break;
  }
}
